import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storageSession from 'redux-persist/lib/storage/session'

//Reducers
import {
  bookingReducer,
  bookingHelperReducer,
  bookingHelperNoPersist,
} from 'state/booking/reducer'

import { patientDashboardReducer } from 'state/dashboard/patient/reducer'
import { supportDashboardReducer } from 'state/dashboard/support/reducer'
import { consentReducer } from 'state/consent/reducer'
import { globalReducer } from 'state/global/reducer'
import { thrivAuthReducer } from 'state/ThrivAuth/reducer'
import { vfdReducer } from 'state/vfdTasks/reducer'
import { questionnaireReducer } from 'state/questionnaire/reducer'

const persistConfig = {
  key: 'root',
  storage: storageSession, // Persist data in session storage
  whiteList: ['booking', 'bookingHelper', 'consent'], //Reducer that we want to persist
}

const rootReducer = combineReducers({
  booking: bookingReducer,
  bookingHelper: bookingHelperReducer,
  bookingHelperNoPersist,
  patientDashboard: patientDashboardReducer,
  supportDashboard: supportDashboardReducer,
  consent: consentReducer,
  thrivAuth: thrivAuthReducer,
  global: globalReducer,
  vfd: vfdReducer,
  questionnaire: questionnaireReducer,
})

export default persistReducer(persistConfig, rootReducer)
